import { BeachTypeId } from '../types/IBeachType';

function getBeachType(ids: number[]): BeachTypeId | 0 {
    const attributeIds = new Set(ids);

    if (attributeIds.has(136)) { //Песчаный
        return BeachTypeId.SandBeach;
    }
    if (attributeIds.has(137)) { //Галечный
        return BeachTypeId.PebbleBeach;
    }
    if (attributeIds.has(211)) { //Песчано-галечный
        return BeachTypeId.SandPebbleBeach;
    }
    return 0;
}

export default getBeachType;